import * as actionType from "./actionType";
import _ from "lodash";

const initialState = {
  //*GLOBAL*//

  //* REPORTS DAILY ATTENDANCE *//

  reports_daily_attendance_processing: false,
  reports_daily_attendance_success: false,
  reports_daily_attendance_failed: false,
  reports_daily_attendance_data: [],
  reports_daily_attendance_message: "",

  //* REPORTS DOWNLOAD DAILY ATTENDANCE *//

  reports_download_daily_attendance_processing: false,
  reports_download_daily_attendance_success: false,
  reports_download_daily_attendance_failed: false,
  reports_download_daily_attendance_data: [],
  reports_download_daily_attendance_message: "",

  //* EXTERNAL PUNCH EVENTS *//
  external_punch_events_processing: false,
  external_punch_events_data: [],
  external_punch_events_data_map: {},
  external_punch_events_message: "",
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case actionType.REPORTS_DAILY_ATTENDANCE_INITIAL:
      return {
        ...state,
        reports_daily_attendance_processing: false,
        reports_daily_attendance_success: false,
        reports_daily_attendance_failed: false,
        reports_daily_attendance_data: [],
        reports_daily_attendance_message: "",
      };

    case actionType.REPORTS_DAILY_ATTENDANCE_PROCESS:
      return {
        ...state,
        reports_daily_attendance_processing: true,
        reports_daily_attendance_success: false,
        reports_daily_attendance_failed: false,
        reports_daily_attendance_data: [],
        reports_daily_attendance_message: "",
      };

    case actionType.REPORTS_DAILY_ATTENDANCE_SUCCESS: {
      return {
        ...state,
        reports_daily_attendance_processing: false,
        reports_daily_attendance_success: true,
        reports_daily_attendance_failed: false,
        reports_daily_attendance_data: action.data,
        reports_daily_attendance_message: "",
      };
    }

    case actionType.REPORTS_DAILY_ATTENDANCE_FAILED:
      return {
        ...state,
        reports_daily_attendance_processing: false,
        reports_daily_attendance_success: false,
        reports_daily_attendance_failed: true,
        reports_daily_attendance_data: action.data,
        reports_daily_attendance_message: "",
      };

    case actionType.REPORTS_DOWNLOAD_DAILY_ATTENDANCE_INITIAL:
      return {
        ...state,
        reports_download_daily_attendance_processing: false,
        reports_download_daily_attendance_success: false,
        reports_download_daily_attendance_failed: false,
        reports_download_daily_attendance_data: [],
        reports_download_daily_attendance_message: "",
      };

    case actionType.REPORTS_DOWNLOAD_DAILY_ATTENDANCE_PROCESS:
      return {
        ...state,
        reports_download_daily_attendance_processing: true,
        reports_download_daily_attendance_success: false,
        reports_download_daily_attendance_failed: false,
        reports_download_daily_attendance_data: [],
        reports_download_daily_attendance_message: "",
      };

    case actionType.REPORTS_DOWNLOAD_DAILY_ATTENDANCE_SUCCESS: {
      return {
        ...state,
        reports_download_daily_attendance_processing: false,
        reports_download_daily_attendance_success: true,
        reports_download_daily_attendance_failed: false,
        reports_download_daily_attendance_data: action.data,
        reports_download_daily_attendance_message: "",
      };
    }

    case actionType.REPORTS_DOWNLOAD_DAILY_ATTENDANCE_FAILED:
      return {
        ...state,
        reports_download_daily_attendance_processing: false,
        reports_download_daily_attendance_success: false,
        reports_download_daily_attendance_failed: true,
        reports_download_daily_attendance_data: action.data,
        reports_download_daily_attendance_message: "",
      };

    case actionType.FETCH_EXTERNAL_PUNCH_EVENTS:
      return {
        ...state,
        external_punch_events_processing: true,
        external_punch_events_data: [],
        external_punch_events_data_map: {},
        external_punch_events_message: "",
      };

    case actionType.FETCH_EXTERNAL_PUNCH_EVENTS_SUCCESS:
      return {
        ...state,
        external_punch_events_processing: false,
        external_punch_events_data: action.payload,
        external_punch_events_data_map: action.payload.reduce(
          (acc, event) => ({
            ...acc,
            [event.identity_id]: {
              ...(acc[event.identity_id] || {}),
              [event.attendance_date]: event,
            },
          }),
          {}
        ),
        external_punch_events_message: "",
      };

    case actionType.FETCH_EXTERNAL_PUNCH_EVENTS_FAILED:
      return {
        ...state,
        external_punch_events_processing: false,
        external_punch_events_data: [],
        external_punch_events_data_map: {},
        external_punch_events_message: action.payload,
      };

    default:
      return state;
  }
};
